import styled from 'styled-components';

export const AuthStyled = styled.div`
  min-height: 100vh;
  background: linear-gradient(30deg, #9459d0 0%, #027c8b 50%, #0d4693 100%);
`;
